import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';

export function getTags(): Promise<FetchResponse> {
  return portalCustomAPI.fetch('getTags', {});
}
